<template>
  <div v-if="application !== null">
    <div class="block mb-5">
      <!-- ApplicationTitle -->
      <div class="form-item d-flex py-5">
        <label class="w-240px mr-5"><h4>Application Title</h4></label>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="application.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="application.status"></FormSwitch>
        </div>
      </div>
      <!-- Order -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="w-248px my-n2">
          <v-text-field
            v-model="application.order"
            placeholder="請輸入序號"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- img uploader -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Cover Photo</h4>
          <div class="h5 ink-02-medium--text">
            呈現於BU Page及Overview Page <br />
            建議尺寸：420px * 290px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="d-flex flex-grow-1">
          <ImgUploader
            :imageUrl.sync="application.cover_photo"
            dir="application"></ImgUploader>
        </div>
      </div>
      <!-- Detail Page Title -->
      <div class="form-item pt-5 d-flex">
        <label class="w-240px mr-5">
          <h4>Detail Page Title</h4>
        </label>
        <div class="my-n2 flex-grow-1">
          <v-text-field
            v-model="application.detail_page_title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Detail Page Banner</h4>
          <div class="h5 ink-02-medium--text">
            呈現於Detail Page置頂區 <br />
            建議尺寸：1920px * 300px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="d-flex flex-grow-1">
          <ImgUploader
            :imageUrl.sync="application.detail_page_banner"
            dir="application"></ImgUploader>
        </div>
      </div>
    </div>
    <!-- block2 seo setting -->
    <div class="block mb-5">
      <h3 class="px-5 pt-5">SEO settings</h3>
      <!-- Title -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Title</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="application.seo_title"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Description -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Description</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-textarea
            v-model="application.seo_description"
            outlined
            dense
          ></v-textarea>
        </div>
      </label>
      <!-- Slug -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Slug</h4>
          <div class="h5 ink-02-medium--text">
            全語系共用 <br />
            建議：英文, 僅可接受dash or underline
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="application.slug"
            placeholder="可讀性URL"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
    </div>
    <!-- TextEditor -->
    <editor
      v-model="application.content"
      :height="400"
      :plugins="'link image lists'"
      :toolbar="'undo redo | link|fontsize select forecolor|image|bullist numlist|outdent indent|alignleft aligncenter alignright|bold'"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import Editor from '@/components/TinymceEditor.vue';

export default {
  components: {
    FormSwitch,
    ImgUploader,
    Editor,
  },
  data: () => ({
    isShow: false,
  }),
  computed: {
    ...mapState('language', ['countries']),
    ...mapState('application', ['application']),
  },
  methods: {
  },
};
</script>

<style></style>
